import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IUserInfo } from '../../../ts/models/IUserInfo';
import { IContent } from '../../../ts/ServerApi/types/IContent';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { ISharedWithMeCustomViewInfo } from '../../models/ISharedWithMeContentInfo';

export interface IShareAction {
  id: string;
  contentId: number;
  contentType: ExplorableItemType;
  createdAt: string;
  isSharerDeleted: boolean;
  message: string;
  sharerId: number;
  underhoodCustomizedViewId?: string;
}

// getSharedWithMe API response interface
export interface IGetSharedWithMeResult extends IGetItemsResult {
  content: IContent[];
  deletedSharers: IUserInfo[];
  owners: IUserInfo[];
  sharers: IUserInfo[];
  shareActions: IShareAction[];
  viewsWithShareActivity: number[];
  underhoodCustomizedViews: ISharedWithMeCustomViewInfo[];
}

export class GetSharedWithMeRequest extends Request<IGetItemsParams, IGetSharedWithMeResult> {
  constructor(params: IGetItemsParams) {
    super('getSharedWithMe', params);
  }
}
